import Loader from 'component/loader'
import { useAgency } from 'context/agency'
import React from 'react'

function SideNAvButtonGradient({
  type,
  disabled,
  label,
  processing,
  children,
  onClick,
  className,
}) {
  const { agency } = useAgency()
  const btn_bg = agency.location_config?.sidenav_button_bg_color
  const btn_text = agency.location_config?.sidenav_button_text_color

  console.log(agency)

  return (
    <button
      style={{ backgroundColor: btn_bg, color: btn_text }}
      onClick={onClick}
      type={type || 'button'}
      class={`${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } text-[#F35658] ${className} bg-gradient-to-br ${
        btn_bg ? '' : 'bg-white'
      } ${
        btn_text ? '' : 'text-[#F35658]'
      } hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-green-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
      disabled={disabled || processing}
    >
      {processing ? <Loader /> : label || children}
    </button>
  )
}

export default SideNAvButtonGradient
